import { render } from "./dewas-add.vue?vue&type=template&id=fcedd414"
import script from "./dewas-add.vue?vue&type=script&lang=js"
export * from "./dewas-add.vue?vue&type=script&lang=js"

import "./dewas-add.vue?vue&type=style&index=0&id=fcedd414&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__